import {initGlobals} from './initGlobals';

export * from '@gongxigames/framework/slot/types/EnvironmentProperty';
export * from '@gongxigames/framework/slot/fragments/SplashScreen';

initGlobals();
